export const chatReducer = (chat = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case "INITIALIZE_SET_UNREAD":
      return {
        ...chat,
        unread: { ...chat?.unread, [payload]: 1 },
      };
    case "INCREMENT_SET_UNREAD":
      return {
        ...chat,
        unread: { ...chat.unread, [payload]: (chat.unread[payload] += 1) },
      };
    case "FIRST_RENDER_CHAT_UNREAD":
      return {
        ...chat,
        unread: payload,
      };
    case "SET_AS_READ":
      return {
        ...chat,
        unread: { ...chat.unread, [payload]: 0 },
      };
    default:
      return chat;
  }
};
